import Icon from "@core-components/icon/Icon";
import EPublicRoutes from "@core-types/routes.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Text } from "@mantine/core";
import { ReviewHelper } from "@modules/review/utils/Review.helper";
import type { FC } from "react";
import { Link } from "react-router";

interface Props {
  className?: string;
}

const ReviewLabel: FC<Props> = ({ className }) => {
  const { t } = useAppTranslation("common.reviews");

  return (
    <Link rel="noreferrer noopener" target="_blank" to={EPublicRoutes.REVIEWS}>
      <Group
        className={`gradient-truspilot-banner w-64 rounded-b-xl p-4 ${className}`}
        wrap="nowrap"
      >
        <Icon.TrustpilotStartFilled className="flex-1" size={250} />

        <Text className="text-wrap font-inter font-normal text-primary-white">
          {t("excellentOn")} <br />{" "}
          <Text span fw={700}>
            {t("trustpilot")}
          </Text>
        </Text>

        <Group gap={5} wrap="nowrap">
          <Text
            className="font-bold font-inter text-primary-white"
            fw={700}
            size="lg"
          >
            {ReviewHelper.AVERAGE_GRADE}
          </Text>
          <Text
            className="text-nowrap font-bold font-inter text-primary-dark-text"
            fw={700}
            size="lg"
          >
            / 5
          </Text>
        </Group>
      </Group>
    </Link>
  );
};

export default ReviewLabel;
